import type { ComponentType, ReactElement } from 'react'

import Allibo from './sections/Allibo'
import BannerCategory from './sections/BannerCategory/BannerCategory'
import BannerCategoryPlp from './sections/BannerCategoryPlp'
import BrandCarousel from './sections/BrandCarousel'
import CardsCustom from './sections/CardCustom/CardsCustom'
import Carousel from './sections/Carousel'
import CarouselInformative from './sections/CarouselInformative'
import ClerkioShelf from './sections/Clerkio/ClerkioShelf'
import ClubInformation from './sections/ClubInformation'
import FAQComponent from './sections/FAQComponent/FAQComponent'
import FlyerComponent from './sections/FlyerComponent'
import FlyerMobileApp from './sections/FlyerMobileApp/FlyerMobileApp'
import HeroCard from './sections/HeroCard'
import HeroCarousel from './sections/HeroCarousel'
import HeroCarouselNew from './sections/HeroCarouselNew/HeroCarouselNew'
import Incentives from './sections/Incentives'
import IndispensabiliNavigation from './sections/IndispensabiliNavigation'
import InfoCardCustom from './sections/InfoCardCustom/InfoCardCustom'
import NewsletterCustom from './sections/NewsletterCustom'
import OffersCarousel from './sections/OffersCarousel'
import RawCodeRender from './sections/RawCodeRender'
import RichText from './sections/RichText'
import ShopServices from './sections/ShopServices'
import SmartBrands from './sections/SmartBrands/SmartBrands'
import TrustPilotBox from './sections/TrustpilotBox/TrustpilotBox'
import VideoCollection from './sections/VideoCollection'
//  * Sections: Components imported from '../components/sections' only.
//  * Do not import or render components from any other folder in here.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const COMPONENTS: Record<string, ComponentType<any>> = {
  ClubInformation,
  SmartBrands,
  Carousel,
  BannerCategory,
  Incentives,
  NewsletterCustom,
  InfoCardCustom,
  ShopServices,
  HeroCard,
  TrustPilotBox,
  FAQComponent,
  RichText,
  BrandCarousel,
  BannerCategoryPlp,
  IndispensabiliNavigation,
  CarouselInformative,
  HeroCarousel,
  HeroCarouselNew,
  ClerkioShelf,
  VideoCollection,
  CardsCustom,
  Allibo,
  FlyerComponent,
  OffersCarousel,
  RawCodeRender,
  FlyerMobileApp,
}

interface Props {
  sections?: Array<{
    name: string
    data: {
      componentDivider?: string
    }
  }>
  divider?: string
}

function RenderCMS({ sections, divider }: Props) {
  const components: ReactElement[] = []

  sections?.forEach(({ name, data }, index) => {
    const Component = COMPONENTS[name]

    if (!Component) {
      console.info(
        `%c Could not find the component ${name}
        Add a new component for this block or remove it from the CMS`,
        'background: #111; color: #900C3F; font-family: roboto, sans-serif; font-size: 1rem;'
      )
    } else if (
      (divider === 'after' && data.componentDivider === 'after') ||
      (divider === 'before' && data.componentDivider === 'before') ||
      (divider !== 'after' && divider !== 'before')
    ) {
      components.push(<Component key={`cms-section-${index}`} {...data} />)
    }
  })

  return <>{components}</>
}

export default RenderCMS
